const $721372394a8bdcc1$export$ca000e230c0caa3e = {
    data: []
};
const $721372394a8bdcc1$export$8ea9b17c5f70aae9 = async function(data) {
    $721372394a8bdcc1$export$ca000e230c0caa3e.data.push(data);
/*
  try {
    const response = await fetch(
      "https://script.google.com/macros/s/AKfycbyBK7L5IYndhOF7i5AONVK1XU_keI4XfAScPfD2Q7N4VHbZs73qmEcot20iso4SmSMx/exec",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      }
    );
    if (!response.ok) throw new Error("Network response was not ok");
    const result = await response.json();
    console.log(result);
  } catch (error) {
    console.error("Fetch error:", error);
  }
  */ };


class $e0f8393c9d2414d9$var$ContactView {
    parentEl = document.querySelector("#contactForm");
    modal = document.querySelector(".modal");
    overlay = document.querySelector(".modal__overlay");
    btnCloseModal = document.querySelector(".button--close");
    btnsOpenModal = document.querySelectorAll(".btn--show-modal");
    constructor(){
        this.addHandlerOpenWindow();
        this.addHandlerCloseWindow();
    }
    openModal = function() {
        this.modal.classList.remove("hidden");
        this.overlay.classList.remove("hidden");
    };
    closeModal = function() {
        this.modal.classList.add("hidden");
        this.overlay.classList.add("hidden");
    };
    addHandlerOpenWindow() {
        this.btnsOpenModal.forEach((btn)=>{
            btn.addEventListener("click", this.openModal.bind(this));
        });
    }
    addHandlerCloseWindow() {
        this.btnCloseModal.addEventListener("click", this.closeModal.bind(this));
        this.overlay.addEventListener("click", this.closeModal.bind(this));
    // document.addEventListener("keydown", (e) => {
    //   if (e.key === "Enter") this.closeModal();
    // });
    }
    addHandlerSubmitForm(handler) {
        this.parentEl.addEventListener("submit", (e)=>{
            e.preventDefault();
            const dataArr = [
                ...new FormData(this.parentEl)
            ];
            const data = Object.fromEntries(dataArr);
            this.closeModal();
            handler(data);
        });
    }
}
var $e0f8393c9d2414d9$export$2e2bcd8739ae039 = new $e0f8393c9d2414d9$var$ContactView();


class $a3471b4623e4e20e$var$NavToggleView {
    parentEl = document.querySelector(".nav__links");
    navToggle = document.querySelector(".nav__toggle");
    constructor(){
        this.checkViewportWidth(); // Check width on load
        window.addEventListener("resize", this.checkViewportWidth.bind(this)); // Listen for resize
        this.addhandlerToggle();
    }
    checkViewportWidth() {
        if (window.innerWidth <= 985) this.parentEl.classList.add("hidden");
        else this.parentEl.classList.remove("hidden");
    }
    toggleNav() {
        this.parentEl.classList.toggle("hidden");
        console.log("toggle");
    }
    hideNav() {
        if (window.innerWidth <= 985) this.parentEl.classList.add("hidden");
    }
    addhandlerToggle() {
        [
            "click"
        ].forEach((ev, i)=>{
            this.navToggle.addEventListener(ev, this.toggleNav.bind(this));
            this.parentEl.addEventListener(ev, (e)=>{
                const link = e.target.closest(".nav__link");
                if (!link) return;
                console.log("hide");
                this.hideNav();
            });
        });
    }
}
var $a3471b4623e4e20e$export$2e2bcd8739ae039 = new $a3471b4623e4e20e$var$NavToggleView();


class $4cb81d2d71c124b1$var$SliderView {
    parentEl = document.querySelector(".slider");
    sliderHeading = document.querySelector(".slider__heading");
    forkifyHeading = document.querySelector(".forkify__heading");
    headings = Array.from(document.querySelectorAll(".slider__heading"));
    newHeadings = [
        "Pokemon Deck Builder",
        "Forkify Recipe App",
        "To Do List"
    ];
    longHeadings = [
        "Pokemon Deck Building App",
        "Forkify: Recipe Search Application",
        "To Do List"
    ];
    constructor(){
        window.addEventListener("resize", this.checkViewportWidth.bind(this));
    }
    checkViewportWidth() {
        if (window.innerWidth <= 450) this.headings.forEach((h, i)=>{
            h.textContent = this.newHeadings[i];
        });
        else this.headings.forEach((h, i)=>{
            h.textContent = this.longHeadings[i];
        });
    }
}
var $4cb81d2d71c124b1$export$2e2bcd8739ae039 = new $4cb81d2d71c124b1$var$SliderView();


// class EyebrowsView {
//   eyebrows = document.querySelectorAll(".eyebrow");
//   constructor() {
//     this.addHandlerChangeEyebrow();
//     window.addEventListener("resize", this.checkViewportWidth.bind(this));
//     window.addEventListener("load", this.checkViewportWidth.bind(this));
//   }
//   checkViewportWidth() {
//     if (window.innerWidth <= 450) {
//       this.eyebrows.forEach((eyebrow) => {
//         eyebrow.style.fontSize = "1.6rem";
//         eyebrow.style.fontWeight = "600";
//         const heading = eyebrow.textContent.toUpperCase();
//         eyebrow.textContent = heading;
//       });
//     } else {
//       this.eyebrows.forEach((eyebrow) => {
//         eyebrow.style.fontSize = "2.4rem";
//         eyebrow.style.fontWeight = "600";
//         const heading = eyebrow.textContent.toUpperCase();
//         eyebrow.textContent = heading;
//       });
//     }
//   }
//   addHandlerChangeEyebrow() {}
// }
// export default new EyebrowsView();


"use strict";
// Elements
const $f445f032c2bd86f5$var$header = document.querySelector(".header");
const $f445f032c2bd86f5$var$nav = document.querySelector(".nav");
const $f445f032c2bd86f5$var$overview = document.querySelector("#overview");
const $f445f032c2bd86f5$var$navLinks = document.querySelector(".nav__links");
const $f445f032c2bd86f5$var$navItem = document.querySelectorAll(".nav__link");
const $f445f032c2bd86f5$var$allSections = document.querySelectorAll(".section");
const $f445f032c2bd86f5$var$navToggle = document.querySelector(".nav__toggle");
// Event handlers
document.querySelector("body").addEventListener("click", function(e) {});
//////////////////////////////////////////
// Reveal Sections
const $f445f032c2bd86f5$var$revealSection = function(entries, observer) {
    const [entry] = entries;
    if (!entry.isIntersecting) return;
    entry.target.classList.remove("section--hidden");
};
const $f445f032c2bd86f5$var$sectionObserver = new IntersectionObserver($f445f032c2bd86f5$var$revealSection, {
    root: null,
    threshold: 0.15
});
$f445f032c2bd86f5$var$allSections.forEach(function(section) {
    // section.classList.add("section--hidden");
    $f445f032c2bd86f5$var$sectionObserver.observe(section);
});
//////////////////////////////////////////
// Sticky nav
const $f445f032c2bd86f5$var$navHeight = $f445f032c2bd86f5$var$nav.getBoundingClientRect().height;
const $f445f032c2bd86f5$var$stickyNav = function(entries, observer) {
    const [entry] = entries;
    console.log(entry);
    if (!entry.isIntersecting) $f445f032c2bd86f5$var$nav.classList.add("sticky");
    else $f445f032c2bd86f5$var$nav.classList.remove("sticky");
};
const $f445f032c2bd86f5$var$headerObserver = new IntersectionObserver($f445f032c2bd86f5$var$stickyNav, {
    root: null,
    threshold: 0.15,
    rootMargin: `-${$f445f032c2bd86f5$var$navHeight}px`
});
$f445f032c2bd86f5$var$headerObserver.observe($f445f032c2bd86f5$var$header);
//////////////////////////////////////////
// Nav Button Hover effect
const $f445f032c2bd86f5$var$hoverHandler = function(e) {
    if (e.target.classList.contains("nav__link")) {
        const link = e.target;
        const siblings = link.closest(".nav").querySelectorAll(".nav__link");
        const logo = link.closest(".nav").querySelector("img");
        // Lighten siblings and logo
        siblings.forEach((el)=>{
            if (e.target !== el) el.style.opacity = this;
        });
    // logo.style.opacity = this;
    }
};
$f445f032c2bd86f5$var$navLinks.addEventListener("mouseover", $f445f032c2bd86f5$var$hoverHandler.bind(0.5));
$f445f032c2bd86f5$var$navLinks.addEventListener("mouseout", $f445f032c2bd86f5$var$hoverHandler.bind(1));
//////////////////////////////////////////
// Underline effect
const $f445f032c2bd86f5$var$underline = document.querySelector(".underline");
window.addEventListener("load", function(e) {
    if (!$f445f032c2bd86f5$var$underline) return;
    $f445f032c2bd86f5$var$underline.classList.add("underline--active");
});
//////////////////////////////////////////
// Jump to sections
$f445f032c2bd86f5$var$nav.querySelectorAll(".nav__item").forEach((item)=>item.addEventListener("click", function(e) {
        e.preventDefault();
        const id = e.target.getAttribute("href");
        if (!id) return;
        const targetSection = document.querySelector(id);
        const navHeight = $f445f032c2bd86f5$var$nav.getBoundingClientRect().height;
        console.log(targetSection, id);
        const yOffsetInitial = window.pageYOffset === 0 ? -navHeight + 10 : 0;
        const yOffset = -navHeight;
        const yPosition = targetSection.getBoundingClientRect().top + (window.pageYOffset + yOffsetInitial) + yOffset;
        console.log(window.pageYOffset);
        window.scrollTo({
            top: yPosition,
            behavior: "smooth"
        });
    // document.querySelector(id).scrollIntoView({ behavior: "smooth" });
    }));
//////////////////////////////////////////
// Slider
const $f445f032c2bd86f5$var$slider = document.querySelector(".slider");
const $f445f032c2bd86f5$var$slides = document.querySelectorAll(".slide");
const $f445f032c2bd86f5$var$btnRight = document.querySelector(".slider__btn--right");
const $f445f032c2bd86f5$var$btnLeft = document.querySelector(".slider__btn--left");
const $f445f032c2bd86f5$var$dotsContainer = document.querySelector(".dots");
// Default working view
// slider.style.overflow = "visible";
// slider.style.scale = "0.5";
// slider.style.transform = "translateX(-700px)";
const $f445f032c2bd86f5$var$sliderCode = function() {
    let curSlide = 0;
    const maxSlide = $f445f032c2bd86f5$var$slides.length;
    const createDots = function(slide) {
        // select container and populate with dot html
        $f445f032c2bd86f5$var$slides.forEach(function(_, i) {
            $f445f032c2bd86f5$var$dotsContainer.insertAdjacentHTML("beforeend", `<button class="dots__dot dots__dot--active" data-slide="${i}"></button>`);
        });
    };
    const activateDots = function(slide) {
        // Reset dots to non active
        document.querySelectorAll(".dots__dot").forEach(function(dot) {
            dot.classList.remove("dots__dot--active");
        });
        // assign active dot
        document.querySelector(`.dots__dot[data-slide="${slide}"]`).classList.add("dots__dot--active");
    };
    const goToSlide = function(slide) {
        $f445f032c2bd86f5$var$slides.forEach(function(s, i) {
            s.style.transform = `translateX(${(i - slide) * 100}%)`;
        });
    };
    const nextSlide = function() {
        if (curSlide === maxSlide - 1) curSlide = 0;
        else curSlide++;
        goToSlide(curSlide);
        activateDots(curSlide);
    };
    const prevSlide = function() {
        if (curSlide === 0) curSlide = maxSlide - 1;
        else curSlide--;
        goToSlide(curSlide);
        activateDots(curSlide);
    };
    $f445f032c2bd86f5$var$btnRight.addEventListener("click", nextSlide);
    $f445f032c2bd86f5$var$btnLeft.addEventListener("click", prevSlide);
    $f445f032c2bd86f5$var$dotsContainer.addEventListener("click", function(e) {
        if (e.target.classList.contains("dots__dot")) {
            curSlide = +e.target.dataset.slide;
            goToSlide(curSlide);
            activateDots(curSlide);
        }
    });
    const initSlider = function(slide) {
        createDots(curSlide);
        goToSlide(0);
        activateDots(curSlide);
    };
    initSlider(curSlide);
};
$f445f032c2bd86f5$var$sliderCode();
/////////////////////////////////////////
// Tabbed Section
const $f445f032c2bd86f5$var$tabs = document.querySelector(".tabs");
const $f445f032c2bd86f5$var$tabsBtnsContainer = document.querySelector(".tabs__btns");
const $f445f032c2bd86f5$var$tabsBtns = document.querySelectorAll(".tabs__btn");
const $f445f032c2bd86f5$var$tabsContent = document.querySelectorAll(".tabs__content");
// Tab btn active
// tabsBtnsContainer.addEventListener("click", function (e) {
//   e.preventDefault();
//   if (!e.target.classList.contains("tabs__btn")) return;
//   tabsBtns.forEach(function (btn) {
//     btn.classList.remove("tabs__btn--active");
//     e.target.classList.add("tabs__btn--active");
//   });
//   // Switch active tab content
//   tabsContent.forEach(function (tab) {
//     tab.classList.remove("tabs__content--active");
//   });
//   document
//     .querySelector(`.tabs__content--${e.target.dataset.tab}`)
//     .classList.add("tabs__content--active");
// });
//////////////////////////////////////
// Controller
const $f445f032c2bd86f5$var$controlSubmitForm = function(data) {
    $721372394a8bdcc1$export$8ea9b17c5f70aae9(data);
    console.log($721372394a8bdcc1$export$ca000e230c0caa3e);
};
const $f445f032c2bd86f5$var$init = function() {
    (0, $e0f8393c9d2414d9$export$2e2bcd8739ae039).addHandlerSubmitForm($f445f032c2bd86f5$var$controlSubmitForm);
};
$f445f032c2bd86f5$var$init();


//# sourceMappingURL=index.4b1fe657.js.map
